import React, { useEffect, useState } from 'react';
import { createPageSnapshot } from './analytics/sessionTracking';
import { trackVisitorSession } from './analytics/visitorMetrics';
import blogPosts from './data/blogPosts.json';
import BlogArticlePage from './pages/BlogArticlePage';
import BlogIndexPage from './pages/BlogIndexPage';
import CvPage from './pages/CvPage';
import HomePage from './pages/HomePage';
import LastNutPage from './pages/LastNutPage';
import NotFoundPage from './pages/NotFoundPage';
import { applyDocumentMetadata, getRouteMetadata } from './routing/metadata';
import { resolveRoute } from './routing/routes';

function readLocation() {
  return {
    pathname: window.location.pathname,
    search: window.location.search,
    href: window.location.href,
  };
}

function App() {
  const [location, setLocation] = useState(readLocation);
  const route = resolveRoute(location.pathname, blogPosts);
  const {
    title: routeTitle,
    description: routeDescription,
    url: routeUrl,
    robots: routeRobots,
  } = getRouteMetadata(route, location.pathname);

  useEffect(() => {
    const handlePopState = () => setLocation(readLocation());
    window.addEventListener('popstate', handlePopState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(
    () =>
      applyDocumentMetadata({
        title: routeTitle,
        description: routeDescription,
        url: routeUrl,
        robots: routeRobots,
      }),
    [routeDescription, routeRobots, routeTitle, routeUrl]
  );

  useEffect(() => {
    async function trackPathChange() {
      try {
        const snapshot = createPageSnapshot(location, routeTitle);
        await trackVisitorSession(snapshot);
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('Visitor tracking failed:', error);
        }
      }
    }

    trackPathChange();
  }, [location, routeTitle]);

  if (route.name === 'home') return <HomePage />;
  if (route.name === 'cv') return <CvPage />;
  if (route.name === 'last-nut') return <LastNutPage />;
  if (route.name === 'blog-index') return <BlogIndexPage posts={blogPosts} />;
  if (route.name === 'blog-article') return <BlogArticlePage post={route.post} />;
  return <NotFoundPage />;
}

export default App;
